import React from 'react';
import Feature from '../../../Common/Feature/Feature';
import styles from './Features.module.scss';

const Features = () => {
  const data1: Array<string> = [
    "Whatsapp ",
    "Instagram",
    "Facebook Commerce",
    "Telegram ",
    "Google Business ",
    "Web Bots",
    "Open AI",
  ];

  const data2: Array<string> = [
    "Product Catalogs",
    "Cart Reminders",
    "Promotions",
    "Payments on Chat",
    "Generate new leads",
    `Drive Repeat Purchase`, `Customer Loyalties`, `Up-selling Workflows`, `Cross selling workflows`, `Notifications`, `Abandoned Cart `, `Outbound Marketing `, `Sales Agent Targets`,
  ];

  const data3: Array<string> = [
    "FoodTech",
    "HealthTech",
    "EdTech",
    "FinTech",
    "LegalTech",
    "Consumer Brands",
    "Retail Industry",
    "B2B",
    "SAAS ",
    "Marketing Agencies",
    "Hospitality & Travel",
    "Entertainment ",
    "Influencers",
    "Beauty Others",


  ];

  const data4: Array<string> = [
    "Multi-lingual Support",
    "NLU ",
    "NLP",
    "Multi Agent  Support ",
    "Ticketing Systems",
    "CRM Automations",
    "Value Chain workflows",
    "Supply Chain Workflows ",


  ];

  return (
    <div className={styles['features-wrapper']}>
      <div className={styles['box1']}>
        <Feature
          heading="Administrations"
          subHeading="One Click On-boardings"
          data={data1}
        />
        <Feature
          heading="Operations"
          subHeading="Cataloging - Product Listing & Inventory"
          data={data2}
        />
        <Feature
          heading="Hooks"
          subHeading="Business Integrations"
          data={data3}
        />

        <Feature
          heading="Customer Engagement"
          subHeading="with Interaction Suite"
          data={data4}
        />
      </div>
    </div>
  );
};

export default Features;
